import { MicroFrontEndContainer } from './mf';

function App() {
  return (
    <div id="skeleton-wrapper" data-testid="skeleton-wrapper">
      <MicroFrontEndContainer id="mf-magic" mfName="mf-magic" />
    </div>
  );
}

export default App;
